// link
import { Link, useNavigate, useLocation } from "react-router";
// style
import './style/header.css'
// routes
import { RoutesClient } from "../../features/routes/routes";
// icon
import { IconMenu2, IconMenu4, IconPhoneCall } from "@tabler/icons-react";
// hook
import { useEffect, useState } from "react";
// mobile nav
import MobileNav from "../../components/mobileNav/mobileNav";
import HeaderNav from "../../components/headerNav/headerNav";
// controller
import useGetData from "../../hook/getData";
import { GetCategories } from "../../services/client/categories/getCategories";
// context 
import ModalSearch from "../../components/modal/search";
import CategoryModal from "../../components/modal/category";
import OffCanvas from "../../components/mobileNav/offcanvas";
import { RoutesUser } from "./../../features/routes/userRouts";
import { getAllAddresses } from "../../features/address/address";
import CategoryCollapse from "../../components/modal/categoryModal";
import CategoryCanvas from "../../components/modal/categoryCanvas";



/* ------------------------------  NEW: NORMALIZER  ------------------------------ */
export function normalizeCategories(categories: any[]) {

    const map: any = {};
    const roots: any[] = [];

    // map
    categories.forEach(cat => {
        map[cat.id] = { ...cat, children: [] };
    });

    // build tree
    categories.forEach(cat => {

        if (cat.parents && cat.parents.length > 0) {

            cat.parents.forEach((parent: any) => {
                if (map[parent.id]) {
                    map[parent.id].children.push(map[cat.id]);
                }
            });

        } else {
            roots.push(map[cat.id]);
        }

    });

    return roots;
}

const DetailHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const [categoryTree, setCategoryTree] = useState<any[]>([]);
    const [categoryId, setCategoryId] = useState<any>();
    const { data: categoires } = useGetData(['categories'], GetCategories);
    const closeMenu = () => setIsMenuOpen(false);
    const location = useLocation();

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    /* -------------------- APPLY NORMALIZED CATEGORY DATA -------------------- */
    useEffect(() => {
        if (categoires) {
            const tree = normalizeCategories(categoires);
            setCategoryTree(tree);
            document.getElementById('pages-header')?.classList.remove('d-none');
        }
    }, [categoires]);


    const navigate = useNavigate();

    const handleNavigate = (slug: string) => {
        navigate(`/categories/${slug}`);
        const closeModalButton: any = document.getElementById("close-modal");
        if (closeModalButton) closeModalButton.click();
    };

    const currentPath = decodeURIComponent(location.pathname);
    const userRoutes = getAllAddresses(RoutesUser);
    const isUserRoute = userRoutes.includes(currentPath);

    return (
        <>
            <section className="px-md-0 px-3">
                <header className="container mt-4 mb-3">
                    <div id="pages-header" className=" bg-white pages-header">
                        <div className="container py-3 pb-2">
                            <div className="row justify-content-between align-items-center">
                                <div className="col-md-3 col-4 text-start  d-lg-none d-inline-block">
                                    <Link className="navbar-brand align-items-center" to="/">
                                        <img alt="logo" src={require('./../../assets/media/logo/logo.png')} className="logo-img-new" />
                                    </Link>
                                </div>
                                <div className="col-4 d-lg-none d-inline-block">
                                    <div className="d-flex justify-content-end w-100 align-items-center gap-1">
                                        <Link to={'tel:09906332606'} className="btn btn-outline-dark text-balck">
                                            <IconPhoneCall size={16} />
                                        </Link>
                                        <button className="btn btn-outline-dark" data-bs-toggle="offcanvas" data-bs-target={isUserRoute ? '#offcanvas-admin' : '#mobile-canvas'}>
                                            <IconMenu2 size={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <nav className="navbar bg-white navbar-expand-lg py-0">
                            <section className="container px-4">
                                <Link className="navbar-brand d-lg-flex d-none align-items-center" to="/">
                                    <img alt="logo" src={require('./../../assets/media/logo/logo.png')} className="logo-img-new" />
                                </Link>
                                <div className="collapse navbar-collapse justify-content-between align-items-center" id="navbarSupportedContent">
                                    <ul className="navbar-nav align-items-center me-auto font-medium-lg mb-2 mb-lg-0">
                                        <li className="nav-item">
                                            <span
                                                style={{ fontSize: '16px', fontWeight: 'bold' }}
                                                className="nav-link text-black mx-1"
                                                data-bs-target={'#offcanvas-menu'}
                                                data-bs-toggle={'offcanvas'}>
                                                <IconMenu4 className="me-2" />
                                                دسته بندی
                                            </span>
                                        </li>

                                        {RoutesClient.map((address) => (
                                            <HeaderNav
                                                key={address.address}
                                                child={address.child}
                                                show={address.show}
                                                label={address.label}
                                                address={address.address}
                                            />
                                        ))}

                                    </ul>
                                    <div className="actions align-items-center d-lg-flex d-none">
                                        <div className=" text-center position-relative">
                                            <Link className="navbar-brand" to="/">
                                                <img alt="logo" src={require('./../../assets/media/logo/logo.png')} className="logo-img-new d-lg-none d-inline-block" />
                                            </Link>
                                            <input data-bs-toggle="offcanvas" data-bs-target="#modal-search" placeholder="جست و جوی محصول ..." className="form-control font-medium-lg border border-2 d-lg-inline-block d-none rounded rounded-2 ms-3 py-2" />
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-5">
                                            <Link to={'tel:09906332606'} className="btn btn-outline-dark text-balck">
                                                <IconPhoneCall size={16} />
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </section>
                        </nav>

                        {isMenuOpen && (
                            <CategoryCollapse
                                closeModal={closeMenu}
                                parentCategory={categoryTree}
                                categoryId={categoryId}
                                setCategoryId={setCategoryId}
                            />
                        )}
                    </div>
                </header>
            </section>
            <CategoryModal parentCategory={categoryTree} handleNavigate={handleNavigate} />
            <CategoryCanvas parentCategory={categoryTree} handleNavigate={handleNavigate} />
            <ModalSearch />
            {location.pathname !== "/cart" && location.pathname !== '/shop' ? (
                <MobileNav routes={RoutesClient} />
            ) : null}
            <OffCanvas routes={RoutesClient} />
        </>
    );
};

export default DetailHeader;
